// extracted by mini-css-extract-plugin
export default {"button":"CloseButton_button__rcEdp","fullView":"CloseButton_fullView__KptNI","shimmer":"CloseButton_shimmer__Py0uP"};